// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.audit-table-scroll[data-v-7b289061] {\n    max-height: 360px;\n    overflow-y: auto;\n}\n.audit-pre[data-v-7b289061] {\n    margin: 0;\n    white-space: pre-wrap;\n    word-break: break-word;\n    font-size: 12px;\n    line-height: 1.35;\n}\n.audit-row-changed[data-v-7b289061] {\n    background: #fff8e1;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
